import request from '@/utils/request';

//新建模板消息
export function handleAddTempMsg(values) {
  return request('/sms/addTempMsg', {
    method: 'POST',
    data: values,
  });
}

//更新模板消息
export function handleUpdateTempMsg(values) {
  return request('/sms/updateTempMsg', {
    method: 'POST',
    data: values,
  });
}

//查询短信签名列表
export function getSignatureList(values) {
  return request('/sms/querySignatureList', {
    method: 'POST',
    data: values,
  });
}

//短信预览
export function postPreview(values) {
  return request('/sms/preview', {
    method: 'POST',
    data: values,
  });
}

//查询短信模板消息变量定义列表
export function getQueryTempMsgVariableList() {
  return request('/sms/queryTempMsgVariableList', {
    method: 'GET',
    // data: values,
  });
}
